import { render, staticRenderFns } from "./MobileLandingRecoveryComponent.vue?vue&type=template&id=d73a3ff8&"
import script from "./MobileLandingRecoveryComponent.vue?vue&type=script&lang=js&"
export * from "./MobileLandingRecoveryComponent.vue?vue&type=script&lang=js&"
import style0 from "./MobileLandingRecoveryComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d73a3ff8')) {
      api.createRecord('d73a3ff8', component.options)
    } else {
      api.reload('d73a3ff8', component.options)
    }
    module.hot.accept("./MobileLandingRecoveryComponent.vue?vue&type=template&id=d73a3ff8&", function () {
      api.rerender('d73a3ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/recovery/MobileLandingRecoveryComponent.vue"
export default component.exports